import { IconFont } from '@/components';
import { LargeSelect } from '@/components/LargeSelect';
import { useTranslation } from 'react-i18next';
import { ImagePullPolicy, useImageOptionsStore } from './useImageOptionsStore';

const { IF_NOT_PRESENT, ALWAYS, NEVER } = ImagePullPolicy;

export function ImageOptions() {
  const { t } = useTranslation();
  const msg = {
    image_pull_policy_ifnotpresent: t('components:prefer.local.image'),
    image_pull_policy_ifnotpresent_desc: t(
      'components:only.use.local.images.if.the.required.image.does.not.exist.locally.the.container.will.fail',
    ),
    image_pull_policy_always: t('components:always.pull.image'),
    image_pull_policy_always_desc: t(
      'components:always.attempt.to.pull.a.new.image.when.creating.or.updating.pods',
    ),
    image_pull_policy_never: t('components:use.local.image.only'),
    image_pull_policy_never_desc: t('components:use.local.image.if.it.exists'),
  };

  const { imagePullPolicy, updateImagePullPolicy } = useImageOptionsStore();

  const imagePullPolicyOptions = [
    {
      label: (
        <LargeSelect.IconLabel
          label={msg.image_pull_policy_ifnotpresent}
          description={msg.image_pull_policy_ifnotpresent_desc}
          icon={<IconFont name="icon-jingxiangmian" style={{ fontSize: 36 }} />}
        />
      ),
      desc: msg.image_pull_policy_ifnotpresent_desc,
      value: IF_NOT_PRESENT,
    },
    {
      label: (
        <LargeSelect.IconLabel
          label={msg.image_pull_policy_always}
          description={msg.image_pull_policy_always_desc}
          icon={<IconFont name="icon-jingxiangmian" style={{ fontSize: 36 }} />}
        />
      ),
      desc: msg.image_pull_policy_always_desc,
      value: ALWAYS,
    },
    {
      label: (
        <LargeSelect.IconLabel
          label={msg.image_pull_policy_never}
          description={msg.image_pull_policy_never_desc}
          icon={<IconFont name="icon-jingxiangmian" style={{ fontSize: 36 }} />}
        />
      ),
      desc: msg.image_pull_policy_never_desc,
      value: NEVER,
    },
  ];

  return (
    <>
      <LargeSelect
        value={imagePullPolicy}
        onChange={(policy) => updateImagePullPolicy(policy as ImagePullPolicy)}
        options={imagePullPolicyOptions}
      />
    </>
  );
}
